(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskTagAddEdit',
	};

	var form_id = 'tasktagaddedit-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var picker_color = '#0080c5';

		if ($('#' + form_id + 'existing_color').val()) {
			picker_color = $('#' + form_id + 'existing_color').val();
		}

		// init color picker
		$('#colorpicker').spectrum({
			color      : picker_color,
			showInitial: true,
			showInput  : true,
			change     : function changeColor(color) {
				var new_color = color.toHexString().toUpperCase();
				$('#' + form_id + 'color').val(new_color);
			}
		});
	};
}(jQuery, window.Adzuki || {}));
